<template>
<div class="drawerWrap devDetailDW">
   <div class="drawerBody detailsDrawerBody">
      <div class="basic detailsItem">
         <h4>基本信息</h4>
         <div class="details">
            <ul>
               <li>
                  <div class="label">隐患标题:</div>
                  <div class="value">{{datailsData.dangerTitle}}</div>
               </li>
               <li>
                  <div class="label">现场情况:</div>
                  <div class="value">{{datailsData.scene}}</div>
               </li>
               <li>
                  <div class="label">整改意见:</div>
                  <div class="value">{{datailsData.opinion}}</div>
               </li>
               <li>
                  <div class="label">处理结果:</div>
                  <div class="value">{{datailsData.result}}</div>
               </li>
                <li>
                  <div class="label">处理图片:</div>
                  <div class="value"><img :src="baseUrlAddr+datailsData.dangerHandleThumbnail" alt="" style="cursor:pointer" @click="imgMask(datailsData.dangerHandleOriginalPhoto)"></div>
               </li>
               <li>
                  <div class="label">处理人:</div>
                  <div class="value">{{datailsData.handlerNickName}}</div>
               </li>
               <li>
                  <div class="label">处理时间:</div>
                  <div class="value">{{datailsData.createTime}}</div>
               </li>
               <li>
                  <div class="label">签名:</div>
                  <div class="value"><img :src="baseUrlAddr+datailsData.signPicture" alt=""></div>
               </li>
            </ul>
         </div>
      </div>
   </div>
    <div class="imgMasking" v-if="showImg">
    <div class="closeBtn" @click="showImg = false"><i class="el-icon-circle-close" /></div>
    <div class="imgMask">
      <img :src="imgUrl" alt="">
    </div>
  </div>
</div>
</template>

<script>
export default {
   props: {
      datailsData: {
         type: Object,
         default: () => {
            return {};
         }
      }
   },
   data() {
      return {
        imgUrl:'',
        showImg:false,
      };
   },
   watch: {
      datailsData(newV) {
         console.log(newV);

      }
   },
   created() {
      console.log(this.datailsData)

   },
   mounted() {
      
   },
   methods: {
      //图片放大
    imgMask(data) {
      this.imgUrl =this.baseUrlAddr+data
      this.showImg = true
    },
   }
};
</script>

<style lang="scss" scoped>
.devDetailDW{
  .imgMasking {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 50px;
      cursor: pointer;
    }

    .closeBtn {
      position: absolute;
      top: 50px;
      right: 100px;
      font-size: 50px;
      color: #fff;
    }

    .imgMask {
      // width: 600px;
      height: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      // margin-top: -300px;
      // margin-left: -300px;
      transform: translate(-50%, -50%);
      background: #fff;

      img {
        // width: 100%;
        height: 100%;
      }
    }
  }
}
.detailsDrawerBody {
   padding: 10px 35px;

   .detailsItem {
      padding-left: 20px;

      h4 {
         font-size: 16px;
         color: #333;
         line-height: 38px;
         font-weight: bold;
         border-bottom: 1px solid #aaa;
      }

      .details {
         padding: 10px 0;

         ul {

            li {
               line-height: 38px;

               .label {
                  display: inline-block;
                  vertical-align: middle;
                  color: #bbb;
                  width: 120px;
               }

               .value {
                  display: inline-block;
                  vertical-align: middle;
                  color: #888;
                  margin-left: 5px;

                  .unit {
                     margin-left: 10px;
                  }
               }
            }
         }

         .btn {
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -20px;
         }
      }

      &.params {
         .details {
            padding-right: 100px;
            position: relative;
         }
      }

   }

}
</style>